
import { createApiClient } from 'Network/ApiClient';

export const DrugsAxiosInstance = createApiClient('drug/');


